import { c as _c } from "react/compiler-runtime";
interface WaveSettingEditorActionsProps {
  readonly disabled: boolean;
  readonly secondaryAction?: {
    readonly disabled: boolean;
    readonly label: string;
    readonly onClick: () => void;
  } | null;
  readonly onCancel: () => void;
}
export default function WaveSettingEditorActions(t0) {
  const $ = _c(12);
  const {
    disabled,
    onCancel,
    secondaryAction: t1
  } = t0;
  const secondaryAction = t1 === undefined ? null : t1;
  let t2;
  if ($[0] !== disabled || $[1] !== onCancel) {
    t2 = <button type="button" disabled={disabled} onClick={onCancel} className="tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-iron-300 tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-50 desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-text-iron-100">Cancel</button>;
    $[0] = disabled;
    $[1] = onCancel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== disabled || $[4] !== secondaryAction) {
    t3 = secondaryAction && <button type="button" disabled={disabled || secondaryAction.disabled} onClick={secondaryAction.onClick} className="tw-rounded-md tw-border tw-border-solid tw-border-red/40 tw-bg-transparent tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-red tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-50 desktop-hover:hover:tw-border-red desktop-hover:hover:tw-text-red">{secondaryAction.label}</button>;
    $[3] = disabled;
    $[4] = secondaryAction;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled) {
    t4 = <button type="submit" disabled={disabled} className="tw-rounded-md tw-border tw-border-solid tw-border-primary-500 tw-bg-primary-500 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-50 desktop-hover:hover:tw-border-primary-600 desktop-hover:hover:tw-bg-primary-600">Save</button>;
    $[6] = disabled;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-justify-end tw-gap-2">{t2}{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}